import { SelectOptionTitleContainer } from './styles.js';
import { jsx } from 'react/jsx-runtime';

const SelectOptionTitle = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/jsx(SelectOptionTitleContainer, {
    children: text
  });
};

export { SelectOptionTitle };
//# sourceMappingURL=component.js.map
